import { formatSingaporeDate, formatSingaporeDateTime } from "@shared/timezone";

export function formatCurrency(amount: number) {
  return new Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: "SGD",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatVisitDateTime(date: Date | string, arrivalWindow?: string | null) {
  const datePart = formatSingaporeDate(date, {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
  if (arrivalWindow) return `${datePart} · ${arrivalWindow.replace(/-/g, "–")}`;
  return formatSingaporeDateTime(date, {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}
